/**
 * 防抖函数（trailing-edge）：在最后一次调用后等待 wait 毫秒再执行。
 * 保留 this 与参数。
 * @param {Function} fn 需要防抖的函数
 * @param {Number} wait 等待毫秒数，默认 300
 * @returns {Function} 防抖包装后的函数
 */
export default function debounce (fn, wait = 300) {
  let timer = null
  return function (...args) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      timer = null
      fn.apply(this, args)
    }, wait)
  }
}
